import { FormattedMessage } from "react-intl";
import { Container, Row, Col } from "react-bootstrap";

export const Footer = () => (
  <footer className="footer-component pt-4 pb-4">
    <Container fluid>
      <Row>
        <Col className="text-center">
          <span className="d-block d-md-inline-block">
            <FormattedMessage id="component.common.footer.copyright1" />
          </span>
          <span className="hidden-sm"> - </span>
          <span className="d-block d-md-inline-block">
            <FormattedMessage id="component.common.footer.copyright2" />
          </span>
          <span>
            <FormattedMessage
              id="component.common.footer.version"
              values={{ version: process.env.REACT_APP_VERSION }}
            />
          </span>
        </Col>
      </Row>
    </Container>
  </footer>
);
